import { InventoryBatch } from '../types/operations';

export type DateTracking = { tracksExpiry?: boolean; tracksReview?: boolean };
export type DateField = 'expiresOn' | 'reviewOn';
export const tracksDates = (tracking: DateTracking) =>
  !!(tracking.tracksExpiry || tracking.tracksReview);
export const trackingFields = (tracking: DateTracking): DateField[] => [
  ...(tracking.tracksExpiry ? ['expiresOn' as const] : []),
  ...(tracking.tracksReview ? ['reviewOn' as const] : []),
];
export function endOfMonth(year: number, month: number): string {
  if (
    !Number.isInteger(year) ||
    year < 1900 ||
    year > 9999 ||
    !Number.isInteger(month) ||
    month < 1 ||
    month > 12
  )
    throw new Error('INVALID_MONTH');
  const day = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return `${year}-${String(month).padStart(2, '0')}-${day}`;
}
export function effectiveDates(
  batch: InventoryBatch,
  tracking: DateTracking,
): InventoryBatch {
  return {
    id: batch.id,
    storeId: batch.storeId,
    equipmentId: batch.equipmentId,
    quantity: batch.quantity,
    expiresOn: tracking.tracksExpiry ? batch.expiresOn : null,
    reviewOn: tracking.tracksReview ? batch.reviewOn : null,
  };
}
export function dateGroups(batches: InventoryBatch[], field: DateField) {
  const groups = new Map<string, InventoryBatch[]>();
  for (const batch of batches) {
    const key = batch[field]?.slice(0, 7) || '';
    groups.set(key, [...(groups.get(key) || []), batch]);
  }
  if (!groups.has('')) groups.set('', []);
  return [...groups.entries()]
    .sort(([a], [b]) => (a || '9999').localeCompare(b || '9999'))
    .map(([key, items]) => ({
      key,
      items,
      quantity: items.reduce((n, b) => n + b.quantity, 0),
    }));
}
export function fefoAllocations(
  batches: InventoryBatch[],
  quantity: number,
  tracking: DateTracking,
) {
  let remaining = quantity;
  return batches
    .map((b) => effectiveDates(b, tracking))
    .sort((a, b) => {
      const first = (b: InventoryBatch) =>
        [b.expiresOn, b.reviewOn].filter((d): d is string => !!d).sort()[0] ||
        '';
      return first(a).localeCompare(first(b)) || a.id.localeCompare(b.id);
    })
    .flatMap((batch) => {
      const count = Math.max(0, Math.min(batch.quantity, remaining));
      remaining -= count;
      return count ? [{ batchId: batch.id, quantity: count }] : [];
    });
}
